"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_dom_1 = require("react-dom");
var TexTranslator_1 = require("./components/TexTranslator");
var mountPoint = document.getElementById("mount-point");
if (mountPoint)
    react_dom_1.render(React.createElement(TexTranslator_1.TexTranslator, null), mountPoint);



//////////////////
// WEBPACK FOOTER
// ./src/ts/app.tsx
// module id = 80
// module chunks = 0